// src/components/routeFlowsData.js

import axios from "axios";
import config from "../../../config";

const API_URL = config.SYNCHROEU_URL;

// helper that maps a numeric value to a color
const generateShades = (
  values,
  { hue = 200, sat = 70, lightMin = 30, lightMax = 80 } = {}
) => {
  const min = Math.min(...values);
  const max = Math.max(...values);
  return values.map((v) => {
    // normalize v to [0,1]
    const norm = max === min ? 0.5 : (v - min) / (max - min);
    // higher values → darker (lightMin), lower → lighter (lightMax)
    const lightness = lightMax - norm * (lightMax - lightMin);
    return `hsl(${hue}, ${sat}%, ${lightness}%)`;
  });
};

export const routeFlowsData = async (endpoint) => {
  try {
    console.log("syncrh");
    const url = `${API_URL}${endpoint.endPoint}`;
    console.log("route flows url ", url);
    const response = await axios.get(`${API_URL}${endpoint.endPoint}`, {
      headers: { "Accept-Profile": "traffic_athens" },
    });
    // Sort data: descending for Egnatia East, ascending for others
    const sortedData = response.data.sort((a, b) =>
      endpoint.name === "Egnatia East" ? b.id - a.id : a.id - b.id
    );

    // Extract labels
    const labels = sortedData.map((entry) => entry.name);

    // Compute a single "flow" value per entry (sum of in + out)
    // const values = sortedData.map(
    //   (entry) => (entry.value_in ?? 0) + (entry.value_out ?? 0)
    // );
    const values = sortedData.map(endpoint.computeValue);

    // Map each bar to a dynamic color
    // Generate a shade for each bar based on its value
    const backgroundColor = generateShades(values, {
      hue: 200, // your base color hue
      sat: 70, // your base saturation
      lightMin: 30, // darkest for highest values
      lightMax: 80, // lightest for lowest values
    });

    // Build one unified dataset
    const datasets = [
      {
        label: "Total Flow",
        data: values,
        backgroundColor,
        maxBarThickness: 30,
        borderWidth: 0,
      },
    ];

    // Chart options (including DataLabels config)
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        title: {
          display: true,
          text: endpoint.name,
          font: { size: 16 },
          color: "#fff",
        },
        tooltip: {
          callbacks: {
            title: function (tooltipItems) {
              const idx = tooltipItems[0].dataIndex;
              return labels[idx]; // full label shown on hover
            },
          },
        },
        datalabels: {
          anchor: "end",
          align: "end",
          offset: -4,
          formatter: (value) => value,
          font: { size: 12 },
          color: "#636363",
        },
      },

      scales: {
        x: {
          ticks: {
            maxRotation: 45,
            minRotation: 45,
            align: "start",
            // Optional: shorten long labels with ellipsis
            callback: function (val, index, ticks) {
              const label = this.getLabelForValue(val);
              return label.length > 15 ? label.slice(0, 15) + "…" : label;
            },
          },
          grid: { display: false },
        },
        y: {
          beginAtZero: true,
          ticks: { display: false },
          grid: { display: false },
        },
      },
    };

    return {
      id: endpoint.name,
      data: { labels, datasets },
      options,
    };
  } catch (error) {
    console.error(`Error fetching data from ${endpoint.name}:`, error);
    return null;
  }
};
